import { LinkStatus } from 'store/comoLink/types';

export interface GateInput {
  ready: boolean;
  stateError: boolean;
  // Status of the best merchant link of the user, or null when no merchant has a link row.
  linkStatus: LinkStatus | null;
  entry: 'dashboard-page' | 'navigation';
}

export type GateDecision = 'loading' | 'legacy' | 'confirm' | 'auto' | 'blocked' | 'error';

// When the user has several links the best status wins; among equals the first merchant is used.
const STATUS_PRIORITY: LinkStatus[] = ['completed', 'pending', 'failed', 'exhausted'];

const rank = (status: LinkStatus): number => {
  const index = STATUS_PRIORITY.indexOf(status);
  return index === -1 ? STATUS_PRIORITY.length : index;
};

export const pickLinked = <T extends { status: LinkStatus }>(linked: T[]): T | undefined =>
  linked.reduce<T | undefined>(
    (best, item) => (!best || rank(item.status) < rank(best.status) ? item : best),
    undefined
  );

// A user with a link row never reaches the legacy page: a completed link goes to COMO, any other is shown as a state.
// Without a known state the page stays closed too, since the user may be linked.
export function decideGate(input: GateInput): GateDecision {
  if (!input.ready) return 'loading';
  if (input.stateError) return 'error';
  if (input.linkStatus === null) return 'legacy';
  if (input.linkStatus !== 'completed') return 'blocked';
  return input.entry === 'dashboard-page' ? 'auto' : 'confirm';
}
